import { AbstractControl, ValidationErrors } from "@angular/forms";

export const invalidDateRangeValidator = (control: AbstractControl): ValidationErrors | null =>{
    const parent = control?.parent as any;
    if(!parent) return null;
    const startDate = parent?.get('startDate') ? new Date(parent?.get('startDate')?.value) : null;
    const endDate = parent?.get('endDate') ? new Date(parent?.get('endDate')?.value) : null;

    if (startDate && endDate && startDate > endDate) {
        return { invalidDateRange: true };
    }
    return null;
}